import { rem } from 'polished'
import styled from 'styled-components'

export const CommonImporterErrorStageStyled = styled.div`
  font-size: ${rem(16)};

  .fix-options-container {
    background-color: ${(props) => props.theme.colors.offwhite};
  }
`
